export default "__VITE_ASSET__CTFv7uhT__"